/* eslint-disable */
import React, { useState, useEffect, useMemo, useRef } from 'react'
import { withRouter, useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

import {
  FormRef,
  IconeEditar,
  IconeLixeira,
  Tooltip,
  MoedaInputUnform,
  NumeroInputUnform,
  Carregando,
  IconeAtencao
} from 'src/componentes'
import { Botao } from 'src/componentes/botao'
import { Breadcrumb } from 'src/componentes/breadcrumb'
import { Cabecalho } from 'src/componentes/cabecalho'
import { Container as ContainerErroLayout } from 'src/componentes/erro-container-layout/styles'
import {
  focarPrimeiroCampoComErro,
  formatarValorMoeda
} from 'src/componentes/funcoes'
import { IconeBack } from 'src/componentes/icones'
import { Link } from 'src/componentes/link'
import { Modal } from 'src/componentes/modal'
import { ModalRef } from 'src/componentes/modal/tipos'
import { Navegacao } from 'src/componentes/navegacao'
import { SubTitulo } from 'src/componentes/subtitulo'
import {
  CalendarioUnform,
  CheckboxUnform,
  CpfInputUnform,
  DataInputUnform,
  SelectOpcao
} from 'src/componentes/unform'
import { FormUnform } from 'src/componentes/unform/form'
import { InputUnform } from 'src/componentes/unform/input'
import { SelectUnform } from 'src/componentes/unform/select'
import { PesquisaCursoDTO } from 'src/dto'
import { ContainerDadosGrande } from 'src/paginas/professor/meu-cadastro/styles'
import { RotasAcademico, RotasPrecificacao } from 'src/rotas'
import { Api } from 'src/servicos'
import { TipoAcao } from 'src/servicos/api'
import {
  ModoPaginaCadastro,
  FormaPagamentoPorExtenso,
  FormaPagamentoCobranca,
  PlanoPagamentoParcela,
  ModalidadeCurso,
  PlanoPagamentoParcelas
} from 'src/tipos'
import {
  BaseAtivaCurso,
  PrecificacaoCategoria,
  PrecificacaoCategoriaPorExtenso,
  PrecificacaoItem,
  TiposPrecificacao
} from 'src/tipos/precificacao'

import { ModalEditarTesteRef } from '../../cursos/cadastro/componentes/tipos'
import { ModalEditarParcela } from './componentes/modal-incluir-parcela'
import { schema } from './schema'
import {
  Container,
  ContainerMain,
  ContainerLink,
  Conteudo,
  ContainerAcoes,
  ContainerLateral,
  Linha,
  ContainerPequeno,
  ContainerDados,
  ContainerDadosMedio,
  ContainerDadosPequeno,
  ContainerBotaoIcone,
  Secao,
  Tabela,
  Padding,
  TextoConfirmacaoModal
} from './styles'
import { PaginaCadastroProps } from './tipos'

enum Navegacoes {
  DadosPrecificacao = 'dados-precificacao',
  PlanoPagamento = 'plano-pagamento',
  ValoresCurso = 'valores-curso',
  Cursos = 'cursos'
}

const CadastroPrecificacao: React.FC<PaginaCadastroProps> = ({
  match,
  modo
}) => {
  const formRef = useRef<FormRef>(null)
  const modalRef = useRef<ModalRef>(null)
  const modalBaseAtivaRef = useRef<ModalRef>(null)
  const [cursosComBaseAtiva, definirCursosComBaseAtiva] = useState<
    Array<{ cursoId: string; cursoNome: string; base: BaseAtivaCurso }>
  >([])
  const [dadosPendentesConfirmacao, definirDadosPendentesConfirmacao] =
    useState<PrecificacaoItem | null>(null)
  const history = useHistory()
  const [titulo] = useState(
    `${
      modo === ModoPaginaCadastro.Inclusao ? 'Inclusão' : 'Edição'
    } de valores do curso`
  )
  const [pronto, definirPronto] = useState(false)
  const [erro, definirErro] = useState<string | undefined>(undefined)
  const [carregando, definirCarregando] = useState(false)
  const [precificacao, definirPrecificacao] = useState<
    PrecificacaoItem | undefined
  >(undefined)
  const [
    formaPagamentoEdicao,
    definirFormaPagamentoEdicao
  ] = useState<FormaPagamentoCobranca>(null)
  const [parcelas, definirParcelas] = useState<PlanoPagamentoParcela[]>([])
  const [todasParcelasOriginais, definirTodasParcelasOriginais] = useState<PlanoPagamentoParcela[]>([])
  const modalEditarParcelaRef = useRef<ModalEditarTesteRef>(null)
  const [valorParcela, setValorParcela] = useState('')
  const [quantidade, setQuantidadeParcelas] = useState('')
  const [dataVencimento, setDataVencimento] = useState('')

  const [cursosSelecionados, definirCursosSelecionados] = useState<string[]>([])
  const valorFormatado = formatarValorMoeda(valorParcela)
  const [cursos, definirCursos] = useState<PesquisaCursoDTO[]>([])
  // Categoria substitui a antiga combinação checkbox "Precificação Base" +
  // select "Tipo" (Precificacao/Campanha): agora é uma única decisão. Base/Cpf/
  // CampanhaPos usam o formulário de parcelamento (PlanoPagamento); só
  // CampanhaExtensao usa o formulário de valor de matrícula (taxa do curso).
  const [categoria, definirCategoria] = useState<PrecificacaoCategoria>(
    PrecificacaoCategoria.Base
  )
  const ehPrecificacaoBase = categoria === PrecificacaoCategoria.Base
  const tipoCampanha =
    categoria === PrecificacaoCategoria.CampanhaExtensao
      ? TiposPrecificacao.Campanha
      : TiposPrecificacao.Precificacao
  // Só relevante dentro de CampanhaExtensao: marca esta campanha como o valor
  // padrão/institucional daquele curso (equivalente a PlanoBase, mas no ramo
  // de valor de matrícula) - Base/Cpf/CampanhaPos nunca usam este estado.
  const [campanhaExtensaoBase, definirCampanhaExtensaoBase] = useState(false)

  const dadosIniciais = useMemo(() => {
    return precificacao
  }, [precificacao])

  const setFormaPagamentoEdicao = async selecionado => {
    if (!selecionado) {
      await definirFormaPagamentoEdicao(null)
    } else {
      const { id } = selecionado
      await definirFormaPagamentoEdicao(FormaPagamentoCobranca[id])
    }
  }

  // Modalidades de Pós/MBA usadas para filtrar o select de cursos de Campanha
  // Pós - a mesma lista de 8 modalidades citadas em ModalidadeCurso, sem
  // incluir Graduacao (que também cairia em "outros" no filtro genérico).
  const modalidadesPos = [
    ModalidadeCurso.PosGraduacaoEad,
    ModalidadeCurso.PosGraduacaoEadFlex,
    ModalidadeCurso.PosGraduacaoEadFull,
    ModalidadeCurso.PosGraduacaoPresencial,
    ModalidadeCurso.MBAEadFull,
    ModalidadeCurso.MBAEad,
    ModalidadeCurso.PosGraduacaoEadFullIntegracaoInstitucional,
    ModalidadeCurso.PosGraduacaoEadIntegracaoInstitucional
  ]

  const carregarCursos = async () => {
    try {
      if (categoria === PrecificacaoCategoria.CampanhaPos) {
        const listasPos = await Promise.all(
          modalidadesPos.map(modalidade =>
            Api.RequisitarCursosPorModalidade(modalidade)
          )
        )
        definirCursos(listasPos.flatMap(lista => lista ?? []))
      } else if (categoria === PrecificacaoCategoria.CampanhaExtensao) {
        const [cursosLivres, cursosEventos] = await Promise.all([
          Api.RequisitarCursosPorModalidade(ModalidadeCurso.Extensao),
          Api.RequisitarCursosPorModalidade(ModalidadeCurso.Evento)
        ])

        definirCursos([...(cursosLivres ?? []), ...(cursosEventos ?? [])])
      } else {
        // Base/Cpf: lista genérica de cursos que não são Extensão/Evento
        // (Pós, Graduação, MBA etc.), mesmo comportamento de sempre.
        const cursos = await Api.RequisitarListaCursoOutros('')
        definirCursos(cursos ?? [])
      }
    } catch {
      definirCursos([])
    }
  }

  const carregarPrecificacao = async () => {
    try {
      if (modo === ModoPaginaCadastro.Edicao) {
        definirPronto(false)

        const precificacaoParaEditar = await Api.ObterDadosPrecificacao(
          match.params.id
        )

        // Converte todas as parcelas mantendo TODAS do banco (não agrupa)
        const todasParcelas = precificacaoParaEditar.planosPagamento.map(parcela => {
          let formatada = null
          if (parcela.dataVencimento !== null) {
            const data = new Date(parcela.dataVencimento)
            formatada = data.toLocaleDateString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            })
          }
          return {
            id: parcela.id,
            valorParcela: parcela.valorParcela || 0,
            quantidade: parcela.quantidade || 0,
            formaPagamento: parcela.formaPagamento || '',
            cursoId: parcela.cursoId,
            dataVencimento: formatada
          }
        })

        // Agrupa apenas para visualização
        const parcelasAgrupadas = new Map<string, PlanoPagamentoParcela>()
        todasParcelas.forEach(parcela => {
          const chave = `${parcela.quantidade}-${parcela.valorParcela}-${parcela.formaPagamento}`
          if (!parcelasAgrupadas.has(chave)) {
            parcelasAgrupadas.set(chave, parcela)
          }
        })

        definirTodasParcelasOriginais(todasParcelas) // Guarda TODAS
        definirParcelas(Array.from(parcelasAgrupadas.values())) // Mostra agrupadas
        definirCursosSelecionados(precificacaoParaEditar.cursoId ?? [])
        definirPrecificacao({ ...precificacaoParaEditar })
        definirCategoria(precificacaoParaEditar.categoria)
        if (precificacaoParaEditar.categoria === PrecificacaoCategoria.CampanhaExtensao) {
          definirCampanhaExtensaoBase(!!precificacaoParaEditar.precificacaoBase)
        }
      }
    } catch (error) {
      definirErro('Erro ao carregar pesquisa satisfação')
    } finally {
      definirPronto(true)
    }
  }

  const formataData = (data: string | Date): string | null => {
    if (!data) return null

    let dateObj: Date

    if (typeof data === 'string') {
      let dia: number, mes: number, ano: number
      if (data.includes('/')) {
        // Formato dd/mm/yyyy
        const partes = data.split('/')
        dia = Number(partes[0])
        mes = Number(partes[1]) - 1
        ano = Number(partes[2])
      } else if (data.includes('-')) {
        // Formato yyyy-mm-dd
        const partes = data.split('-')
        ano = Number(partes[0])
        mes = Number(partes[1]) - 1
        dia = Number(partes[2])
      }
      if (data.includes('/')) return data
      dateObj = new Date(ano, mes, dia)
    } else {
      dateObj = data
    }

    const dia = String(dateObj.getDate()).padStart(2, '0')
    const mes = String(dateObj.getMonth() + 1).padStart(2, '0')
    const ano = dateObj.getFullYear()

    return `${dia}/${mes}/${ano}`
  }

  function parseDataBR(dataStr: string, lessMonth: boolean): Date | null {
    if (!dataStr) return null
    const [dia, mes, ano] = dataStr.split('/').map(Number)
    return new Date(ano, lessMonth ? mes - 1 : mes, dia)
  }

  const normalizaData = (data: string | Date): Date | null => {
    if (!data) return null

    if (data instanceof Date) {
      return data
    }

    if (typeof data === 'string') {
      if (data.includes('/')) {
        return parseDataBR(data, true)
      }

      if (data.includes('-')) {
        const [ano, mes, dia] = data.split('-').map(Number)
        return new Date(ano, mes - 1, dia)
      }
    }

    return null
  }

  const criarParcelamento = async (precificacaoId: string) => {
    const planoPagamentoParaCriar = cursosSelecionados.flatMap(c => {
      return parcelas.map(p => {
        return {
          ...p,
          cursoId: c,
          precificacaoId: precificacaoId,
          dataVencimento: p.dataVencimento
        }
      })
    })

    try {
      const respostas = await Promise.all(
        planoPagamentoParaCriar.map(parcela =>
          Api.SalvarPlanoPagamento({
            cursoId: parcela.cursoId,
            precificacaoId: parcela.precificacaoId,
            valorParcela: parcela.valorParcela.toString(),
            quantidadeParcelas: parcela.quantidade.toString(),
            formaPagamento: parcela.formaPagamento,
            precificacaoBase: precificacao.precificacaoBase,
            dataVencimento: parcela.dataVencimento
          })
        )
      )

      if (respostas.every(resposta => resposta)) {
        toast('Todos planos de pagamentos foram criados', { type: 'success' })
      }
    } catch (ex) {
      toast('Erro ao criar parcelamento', { type: 'error' })
    }
  }

  const adicionarParcela = async () => {
    const dataFimForm = formRef.current?.getFieldValue('dataFim')
    const dtFim = normalizaData(dataFimForm)
    const dtVenc = normalizaData(dataVencimento)

    if (!formaPagamentoEdicao || !quantidade || !valorFormatado) {
      toast(
        'Informe os dados: Forma de Pagamento, Valor da Parcela e Quantidade',
        {
          type: 'info'
        }
      )
      return
    }

    if (dtFim && dtVenc && dtVenc < dtFim) {
      toast(
        'A data de vencimento da parcela não pode ser menor que a Data de Fim da precificação.',
        { type: 'info' }
      )
      return
    }

    const novaParcela: PlanoPagamentoParcela = {
      quantidade: Number(quantidade),
      valorParcela: Number(valorFormatado),
      formaPagamento: formaPagamentoEdicao,
      dataVencimento: parseDataBR(dataVencimento as any, true)
    }

    // Mesmo critério de duplicidade do backend (quantidade+valor+forma de
    // pagamento) - dá feedback imediato sem depender só da rejeição do
    // servidor no Salvar, que só aparece depois de submeter o formulário
    // inteiro.
    const jaExiste = parcelas.some(
      p =>
        p.quantidade === novaParcela.quantidade &&
        p.valorParcela === novaParcela.valorParcela &&
        p.formaPagamento === novaParcela.formaPagamento
    )

    if (jaExiste) {
      toast(
        `Já existe um parcelamento de ${novaParcela.quantidade}x de R$${novaParcela.valorParcela} para essa forma de pagamento.`,
        { type: 'info' }
      )
      return
    }

    definirParcelas(prevParcelas => [...prevParcelas, novaParcela])
  }

  const excluirParcela = async (parcela: PlanoPagamentoParcela) => {
    // Remove do array agrupado (visualização)
    definirParcelas(prevParcelas => prevParcelas.filter(p => p !== parcela))
    
    // Remove todas as parcelas com mesma combinação do array original
    definirTodasParcelasOriginais(prevOriginais => 
      prevOriginais.filter(p => 
        !(p.quantidade === parcela.quantidade && 
          p.valorParcela === parcela.valorParcela && 
          p.formaPagamento === parcela.formaPagamento)
      )
    )
  }

  const editarParcela = async (parcelaEditada: PlanoPagamentoParcelas) => {
    // Encontra a parcela original que está sendo editada
    const parcelaOriginal = parcelas.find(p => p.id === parcelaEditada.id)
    
    if (!parcelaOriginal) return
    
    // Atualiza o array agrupado (visualização)
    definirParcelas(prevParcelas =>
      prevParcelas.map(parcela =>
        parcela.id === parcelaEditada.id ? parcelaEditada : parcela
      )
    )
    
    // Atualiza TODAS as parcelas no array original que tinham a mesma combinação da original
    definirTodasParcelasOriginais(prevOriginais =>
      prevOriginais.map(parcela => {
        // Se a parcela tinha os mesmos valores da original, atualiza com os novos valores
        if (
          parcela.quantidade === parcelaOriginal.quantidade &&
          parcela.valorParcela === parcelaOriginal.valorParcela &&
          parcela.formaPagamento === parcelaOriginal.formaPagamento
        ) {
          return {
            ...parcela,
            quantidade: parcelaEditada.quantidade,
            valorParcela: parcelaEditada.valorParcela,
            dataVencimento: parcelaEditada.dataVencimento
          }
        }
        return parcela
      })
    )
  }

  const acaoSucesso = async (dadosForm: PrecificacaoItem) => {
    // O form só expõe "categoria" (select único); tipo e precificacaoBase são
    // derivados dela aqui, não vêm mais de inputs próprios no formulário:
    // Base é sempre a base do curso; Cpf/CampanhaPos nunca disputam essa
    // posição; CampanhaExtensao depende do checkbox "valor padrão do curso".
    const dados: PrecificacaoItem = {
      ...dadosForm,
      categoria,
      tipo: tipoCampanha,
      precificacaoBase:
        categoria === PrecificacaoCategoria.Base
          ? true
          : categoria === PrecificacaoCategoria.CampanhaExtensao
          ? campanhaExtensaoBase
          : false
    }

    if (dados.precificacaoBase && cursosSelecionados.length > 0) {
      try {
        const mapaBaseAtiva = await Api.ExisteBaseAtivaParaCursos(
          cursosSelecionados,
          dados.tipo
        )

        const cursosComBase = cursosSelecionados
          .filter(cursoId => {
            const base = mapaBaseAtiva?.[cursoId]
            // Na edição, não conta como conflito a própria precificação sendo editada
            return (
              base?.existe &&
              (modo === ModoPaginaCadastro.Inclusao ||
                base.precificacaoId !== match.params.id)
            )
          })
          .map(cursoId => ({
            cursoId,
            cursoNome: cursos.find(c => c.id === cursoId)?.nome ?? cursoId,
            base: mapaBaseAtiva[cursoId]
          }))

        if (cursosComBase.length > 0) {
          definirCursosComBaseAtiva(cursosComBase)
          definirDadosPendentesConfirmacao(dados)
          modalBaseAtivaRef.current?.abrir()
          return
        }
      } catch {
        // Se a checagem falhar, segue o fluxo normal sem bloquear o cadastro
      }
    }

    await enviarPrecificacao(dados)
  }

  const enviarPrecificacao = async (dados: PrecificacaoItem) => {
    try {
      definirCarregando(true)

      let dadosEnvio

      if (dados.tipo === TiposPrecificacao.Precificacao) {
        let planoPagamentoParaCriar
        
        if (modo === ModoPaginaCadastro.Inclusao) {
          // na criação: cria novas parcelas sem ID para cada curso selecionado
          planoPagamentoParaCriar = cursosSelecionados.flatMap(c => {
            return parcelas.map(p => {
              return {
                id: null,
                quantidade: p.quantidade,
                valorParcela: p.valorParcela,
                formaPagamento: p.formaPagamento,
                cursoId: c,
                dataVencimento: normalizaData(p.dataVencimento)
              }
            })
          })
        } else {
          // Na edição: usa todasParcelasOriginais + filtra por cursos selecionados
          const parcelasExistentes = todasParcelasOriginais
            .filter(p => p.id && p.cursoId && cursosSelecionados.includes(p.cursoId))
            .map(p => ({
              id: p.id,
              quantidade: p.quantidade,
              valorParcela: p.valorParcela,
              formaPagamento: p.formaPagamento,
              cursoId: p.cursoId,
              dataVencimento: normalizaData(p.dataVencimento)
            }))

          // Identifica cursos que já têm parcelas
          const cursosComParcelas = new Set(todasParcelasOriginais.map(p => p.cursoId))
          const cursosNovos = cursosSelecionados.filter(c => !cursosComParcelas.has(c))
          
          // Parcelas novas adicionadas pelo usuário (sem ID no array agrupado)
          const parcelasNovasSemCurso = parcelas.filter(p => !p.id)

          // Criar parcelas novas para TODOS os cursos selecionados
          const parcelasNovasComCurso = cursosSelecionados.flatMap(cursoId => 
            parcelasNovasSemCurso.map(p => ({
              id: null,
              quantidade: p.quantidade,
              valorParcela: p.valorParcela,
              formaPagamento: p.formaPagamento,
              cursoId: cursoId,
              dataVencimento: normalizaData(p.dataVencimento)
            }))
          )
          
          // Para cursos novos, replicar as parcelas únicas
          const parcelasParaCursosNovos = cursosNovos.flatMap(cursoId => {
            // Pega parcelas únicas para replicar
            const parcelasUnicas = new Map()
            todasParcelasOriginais.forEach(p => {
              const chave = `${p.quantidade}-${p.valorParcela}-${p.formaPagamento}`
              if (!parcelasUnicas.has(chave)) {
                parcelasUnicas.set(chave, p)
              }
            })
            
            return Array.from(parcelasUnicas.values()).map(p => ({
              id: null,
              quantidade: p.quantidade,
              valorParcela: p.valorParcela,
              formaPagamento: p.formaPagamento,
              cursoId: cursoId,
              dataVencimento: normalizaData(p.dataVencimento)
            }))
          })

          planoPagamentoParaCriar = [...parcelasExistentes, ...parcelasNovasComCurso, ...parcelasParaCursosNovos]
        }

        dadosEnvio = {
          nome: dados.nome,
          codigo: dados.codigo,
          categoria: dados.categoria,
          cpf: dados.cpf,
          dataInicio: dados.dataInicio,
          dataFim: dados.dataFim,
          parcelas: planoPagamentoParaCriar,
          cursoId: cursosSelecionados,
          precificacaoBase: dados.precificacaoBase
        }
      } else {
        dadosEnvio = {
          nome: dados.nome,
          codigo: dados.codigo,
          categoria: dados.categoria,
          cpf: dados.cpf,
          dataInicio: dados.dataInicio,
          dataFim: dados.dataFim,
          cursosId: dados.cursoId,
          tipo: dados.tipo,
          valorBase: dados.valorBase,
          pctDesconto: dados.pctDesconto,
          precificacaoBase: dados.precificacaoBase
        }
      }

      if (modo === ModoPaginaCadastro.Inclusao) {
        const resposta = await Api.InserirPrecificacao(dadosEnvio)
        if (resposta.success) {
          await criarParcelamento(resposta.idPrecificacao)
        }
      } else {
        await Api.EditarPrecificacao(match.params.id, dadosEnvio)
      }

      toast(
        `Precificação ${
          modo === ModoPaginaCadastro.Inclusao ? 'cadastrada' : 'editada'
        } com sucesso`,
        {
          type: 'success'
        }
      )

      history.push(RotasAcademico.Precificacao)
    } catch (erro) {
      toast('Ops! Aconteceu um erro. Tente novamente.', { type: 'error' })

      // O backend pode processar parcela a parcela e persistir algumas antes
      // de rejeitar outras por duplicidade (sem fazer rollback do que já deu
      // certo) - sem recarregar aqui, a tabela local continua mostrando o que
      // foi TENTADO (inclusive parcelas rejeitadas, que nunca chegaram a
      // existir no servidor), não o que foi de fato persistido. Só se aplica
      // à edição: na inclusão, uma falha em criarParcelamento não deixa a
      // precificação-mãe em estado editável nesta mesma tela.
      if (modo === ModoPaginaCadastro.Edicao) {
        await carregarPrecificacao()
      }
    } finally {
      definirCarregando(false)
    }
  }

  const alterarCategoria = valor => {
    if (valor !== null) {
      definirCategoria(valor.id)
    }
  }

  const opcoesCursos = useMemo(() => {
    return (
      cursos?.map(x => {
        return { id: x.id, texto: x.nome } as SelectOpcao
      }) ?? []
    )
  }, [cursos])

  const cursosAlterado = (valores: SelectOpcao[]) => {
    const novosCursosSelecionados = valores?.length > 0 ? valores.map(v => v.id) : []
    definirCursosSelecionados(novosCursosSelecionados)
  }

  useEffect(() => {
    carregarPrecificacao()
  }, [])

  useEffect(() => {
    if (categoria) {
      carregarCursos()
    }
  }, [categoria])

  // Data obrigatória para Cpf/CampanhaPos sempre, e para CampanhaExtensao só
  // quando ela NÃO é o valor padrão do curso (marcada como padrão, vale
  // indefinidamente como a Base institucional, mesma regra de Base) - mesma
  // lógica do schema.ts.
  const exigeData =
    categoria !== PrecificacaoCategoria.Base &&
    !(categoria === PrecificacaoCategoria.CampanhaExtensao && campanhaExtensaoBase)

  return (
    <>
      {pronto ? (
        <Container>
          <ContainerMain>
            <ContainerLink>
              <Link
                texto="Voltar"
                href={RotasAcademico.Precificacao}
                icone={IconeBack}
              />
            </ContainerLink>
            <Cabecalho>
              <Breadcrumb
                titulo={titulo}
                atalhos={[
                  {
                    texto: 'Financeiro'
                  },
                  {
                    texto: 'Precificação',
                    acao: () => history.goBack()
                  },
                  {
                    texto: titulo
                  }
                ]}
              />
            </Cabecalho>
            <Conteudo>
              <FormUnform
                ref={formRef}
                schema={schema}
                dadosIniciais={dadosIniciais}
                acaoSucesso={acaoSucesso}
                acaoFalha={focarPrimeiroCampoComErro}
              >
                <Secao id={Navegacoes.DadosPrecificacao}>
                  <SubTitulo texto="Dados da Precificação" />
                  <Linha>
                    <ContainerDadosGrande>
                      <InputUnform
                        id="ipt_nome"
                        name="nome"
                        label="Nome da precificação"
                        obrigatorio
                      />
                    </ContainerDadosGrande>
                    <ContainerDadosMedio>
                      <SelectUnform
                        id="slct_categoria"
                        name="categoria"
                        label="Categoria"
                        placeholder="Selecione"
                        opcoes={[
                          {
                            id: PrecificacaoCategoria.Base,
                            texto: PrecificacaoCategoriaPorExtenso.Base
                          },
                          {
                            id: PrecificacaoCategoria.Cpf,
                            texto: PrecificacaoCategoriaPorExtenso.Cpf
                          },
                          {
                            id: PrecificacaoCategoria.CampanhaPos,
                            texto: PrecificacaoCategoriaPorExtenso.CampanhaPos
                          },
                          {
                            id: PrecificacaoCategoria.CampanhaExtensao,
                            texto:
                              PrecificacaoCategoriaPorExtenso.CampanhaExtensao
                          }
                        ]}
                        iconeFechar={false}
                        disabled={modo === ModoPaginaCadastro.Edicao}
                        valorAlterado={alterarCategoria}
                      />
                    </ContainerDadosMedio>
                  </Linha>
                  <Linha>
                    <ContainerPequeno>
                      <InputUnform
                        id="ipt_codigo"
                        name="codigo"
                        label="Código da precificação"
                        disabled={modo === ModoPaginaCadastro.Edicao}
                        obrigatorio
                      />
                    </ContainerPequeno>
                    {categoria === PrecificacaoCategoria.Cpf && (
                      <ContainerPequeno>
                        <CpfInputUnform id="ipt_cpf" name="cpf" label="CPF" />
                      </ContainerPequeno>
                    )}
                    {exigeData && (
                      <>
                        <ContainerPequeno>
                          <CalendarioUnform
                            className="sm"
                            id="ipt_data_inicio"
                            name="dataInicio"
                            label="Data de Início"
                            obrigatorio
                          />
                        </ContainerPequeno>
                        <ContainerPequeno>
                          <CalendarioUnform
                            className="sm"
                            id="ipt_data_fim"
                            name="dataFim"
                            label="Data de Fim"
                            obrigatorio
                          />
                        </ContainerPequeno>
                      </>
                    )}
                  </Linha>
                </Secao>
                {categoria === PrecificacaoCategoria.CampanhaExtensao && (
                  <Secao
                    id={Navegacoes.ValoresCurso}
                    style={{ marginTop: '0' }}
                  >
                    <SubTitulo texto="Valor dos Cursos" />
                    <ContainerDados>
                      <ContainerDados>
                        <CheckboxUnform
                          id="ipt_precificacao_base"
                          name="precificacaoBase"
                          texto="Marcar como valor padrão do curso"
                          tamanho="L"
                          checked={campanhaExtensaoBase}
                          onChange={e =>
                            definirCampanhaExtensaoBase(e.target.checked)
                          }
                        />
                      </ContainerDados>
                      {campanhaExtensaoBase ? (
                        <ContainerDadosPequeno>
                          <MoedaInputUnform
                            id="ipt_valor_base"
                            name="valorBase"
                            label="Valor Base"
                            obrigatorio
                          />
                        </ContainerDadosPequeno>
                      ) : (
                        <ContainerDadosPequeno>
                          <InputUnform
                            id="ipt_pct_desconto"
                            name="pctDesconto"
                            label="Porcentagem de desconto"
                            obrigatorio
                          />
                        </ContainerDadosPequeno>
                      )}
                    </ContainerDados>
                  </Secao>
                )}
                {tipoCampanha === TiposPrecificacao.Precificacao && (
                  <Secao
                    id={Navegacoes.PlanoPagamento}
                    style={{ marginTop: '0' }}
                  >
                    <SubTitulo texto="Planos de Pagamento" />
                    <ContainerDados>
                      <ContainerDadosMedio>
                        <SelectUnform
                          id="slct_formPagamentoParcela"
                          name="formaPagamento"
                          label="Forma de Pagamento"
                          placeholder="Selecione"
                          valorAlterado={setFormaPagamentoEdicao}
                          opcoes={[
                            {
                              id:
                                FormaPagamentoCobranca[
                                  FormaPagamentoCobranca.Boleto
                                ],
                              texto: 'Boleto'
                            },
                            {
                              id:
                                FormaPagamentoCobranca[
                                  FormaPagamentoCobranca.CartaoCredito
                                ],
                              texto: 'Cartão de crédito'
                            },
                            {
                              id:
                                FormaPagamentoCobranca[
                                  FormaPagamentoCobranca.Recorrente
                                ],
                              texto: 'Recorrente'
                            }
                          ]}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosPequeno>
                        <MoedaInputUnform
                          name="valorParcela"
                          label="Valor da parcela"
                          onChange={e => setValorParcela(e.target.value)}
                        />
                      </ContainerDadosPequeno>
                      <ContainerDadosPequeno>
                        <NumeroInputUnform
                          name="quantidade"
                          max={9999}
                          maxLength={4}
                          label="Quantidade de parcelas"
                          onChange={e => setQuantidadeParcelas(e.target.value)}
                        />
                      </ContainerDadosPequeno>
                    </ContainerDados>
                    <ContainerDados
                      style={{
                        alignItems: 'center',
                        justifyContent: 'space-between'
                      }}
                    >
                      <ContainerDadosPequeno>
                        <DataInputUnform
                          name="dataVencimento"
                          label="Data do 1º vencimento"
                          onChange={e => setDataVencimento(e.target.value)}
                        />
                      </ContainerDadosPequeno>
                      <ContainerDadosPequeno>
                        <Botao
                          texto="Adicionar parcelamento"
                          tema="Secundario"
                          type="button"
                          style={{ margin: '0 0 0 auto' }}
                          onClick={() => adicionarParcela()}
                        />
                      </ContainerDadosPequeno>
                    </ContainerDados>
                    <Tabela>
                      <thead>
                        <tr>
                          <th>Quantidade de parcelas</th>
                          <th>Valor</th>
                          <th>Forma de Pagamento</th>
                          {parcelas?.some(p => p.dataVencimento) && (
                            <th>Vencimento</th>
                          )}
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {parcelas?.map((parcela, index) => {
                          return (
                            <tr key={index}>
                              <td align="center">{parcela.quantidade}</td>
                              <td align="center">R$ {parcela.valorParcela}</td>
                              <td align="center">
                                {
                                  FormaPagamentoPorExtenso[
                                    parcela.formaPagamento
                                  ]
                                }{' '}
                              </td>
                              {parcela?.dataVencimento && (
                                // <td align="center">{parcela?.dataVencimento}</td>
                                <td align="center">
                                  {parcela?.dataVencimento
                                    ? formataData(parcela.dataVencimento)
                                    : ''}
                                </td>
                              )}
                              <td align="center">
                                <ContainerBotaoIcone>
                                  <button
                                    type="button"
                                    data-tip="Editar parcela"
                                    data-for={'tooltip-editar-parcela'}
                                    onClick={() => {
                                      modalEditarParcelaRef?.current?.abrir(
                                        parcela
                                      )
                                    }}
                                  >
                                    {IconeEditar}
                                  </button>
                                  <Tooltip
                                    id={'tooltip-editar-parcela'}
                                    place="bottom"
                                    offset={{ top: 10 }}
                                  />
                                </ContainerBotaoIcone>
                              </td>
                              <td align="center">
                                <ContainerBotaoIcone>
                                  <button
                                    type="button"
                                    data-tip="Excluir parcela"
                                    data-for={'tooltip-lixeira-parcela'}
                                    onClick={() => excluirParcela(parcela)}
                                  >
                                    {IconeLixeira}
                                  </button>
                                  <Tooltip
                                    id={'tooltip-lixeira-parcela'}
                                    place="bottom"
                                    offset={{ top: 10 }}
                                  />
                                </ContainerBotaoIcone>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </Tabela>
                  </Secao>
                )}
                <Secao id={Navegacoes.Cursos}>
                  <SelectUnform
                    id="cursoId"
                    name="cursoId"
                    label="Cursos"
                    placeholder="Selecione"
                    opcoes={opcoesCursos}
                    multiplo={true}
                    valorAlteradoMulti={cursosAlterado}
                  />
                  <Padding />
                </Secao>
                <ContainerAcoes>
                  <Botao
                    texto="Cancelar"
                    tema="Secundario"
                    type="button"
                    disabled={carregando}
                    onClick={() => modalRef?.current?.abrir()}
                  />
                  <Botao
                    type="submit"
                    texto="Salvar"
                    carregando={carregando}
                    disabled={carregando}
                  />
                </ContainerAcoes>
              </FormUnform>
            </Conteudo>
          </ContainerMain>
          <ContainerLateral>
            <Navegacao
              itens={[
                {
                  link: Navegacoes.DadosPrecificacao,
                  nome: 'Dados da Precificação'
                },
                ...(tipoCampanha !== TiposPrecificacao.Campanha
                  ? [
                      {
                        link: Navegacoes.PlanoPagamento,
                        nome: 'Planos de Pagamento'
                      }
                    ]
                  : []),
                ...(tipoCampanha === TiposPrecificacao.Campanha
                  ? [
                      {
                        link: Navegacoes.ValoresCurso,
                        nome: 'Valor dos Cursos'
                      }
                    ]
                  : []),
                {
                  link: Navegacoes.Cursos,
                  nome: 'Cursos'
                }
              ]}
            />
          </ContainerLateral>
          <Modal
            ref={modalRef}
            backdrop
            id="modal-confirmacao-cancelamento"
            icone={<></>}
            titulo={'Deseja cancelar?'}
            acaoPrimaria={{
              titulo: 'Sim',
              tipo: 'button',
              acao: () => history.goBack()
            }}
            acaoSecundario={{
              titulo: 'Não',
              tipo: 'button',
              acao: () => modalRef?.current?.fechar()
            }}
          >
            <p>Selecione uma opção</p>
          </Modal>
          <Modal
            ref={modalBaseAtivaRef}
            backdrop
            id="modal-confirmacao-base-ativa"
            icone={IconeAtencao}
            titulo="Já existe uma precificação base ativa"
            acaoPrimaria={{
              titulo: 'Confirmar substituição',
              tipo: 'button',
              acao: async () => {
                modalBaseAtivaRef.current?.fechar()
                if (dadosPendentesConfirmacao) {
                  await enviarPrecificacao(dadosPendentesConfirmacao)
                }
              }
            }}
            acaoSecundario={{
              titulo: 'Cancelar',
              tipo: 'button',
              acao: () => modalBaseAtivaRef.current?.fechar()
            }}
          >
            <TextoConfirmacaoModal>
              <p>
                Os cursos abaixo já possuem uma precificação base ativa. Ao
                confirmar, a precificação atual de cada curso será substituída
                por esta.
              </p>
              <ul>
                {cursosComBaseAtiva.map(({ cursoId, cursoNome, base }) => (
                  <li key={cursoId}>
                    {cursoNome} —{' '}
                    <a
                      href={`${RotasPrecificacao.Edicao}/${base.precificacaoId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {base.precificacaoNome ?? 'ver precificação atual'}
                    </a>
                  </li>
                ))}
              </ul>
            </TextoConfirmacaoModal>
          </Modal>
          <ModalEditarParcela
            ref={modalEditarParcelaRef}
            backdrop
            id="modal-inclur-parcela"
            acaoPrimaria={editarParcela}
          />
        </Container>
      ) : !pronto && !erro ? (
        <Carregando texto="Carregando Precificação ..." />
      ) : (
        <Conteudo>
          <ContainerErroLayout>
            <div>
              {IconeAtencao}
              <p>{erro}</p>
              <div>
                <Botao
                  tema="Padrao"
                  texto="Tentar novamente"
                  onClick={carregarPrecificacao}
                  tamanho="S"
                />
              </div>
            </div>
          </ContainerErroLayout>
        </Conteudo>
      )}
    </>
  )
}

export default withRouter(CadastroPrecificacao)
